import React from 'react';
import '../styles/CookieConsent.css';

interface CookieConsentProps {
    onAccept: () => void;
    onReject: () => void;
}

const CookieConsent: React.FC<CookieConsentProps> = ({ onAccept, onReject }) => {
    const handleReject = () => {
        // Call the onReject callback first, then redirect
        onReject();
        // Redirect to www.openscore.org.uk
        window.location.href = 'https://www.openscore.org.uk';
    };

    return (
        <div className="cookie-consent-overlay">
            <div className="cookie-consent-modal">
                <div className="cookie-consent-header">
                    <h3>Cookie Consent</h3>
                </div>
                <div className="cookie-consent-body">
                    <p>
                        We use cookies to enhance your experience and remember your search preferences. 
                        This includes storing a unique user ID and your last search details to help 
                        pre-fill the search form on future visits.
                    </p>
                    <p>
                        <strong>What we store:</strong>
                    </p>
                    <ul>
                        <li>A unique user identifier (stored for 180 days)</li>
                        <li>Your last search location and preferences</li>
                        <li>Your cookie consent status</li>
                        <li>Google analytics cookies</li>
                    </ul>
                    <p>
                        By accepting, you agree to our use of these cookies. You can change your 
                        preferences at any time by clearing your browser cookies.
                    </p>
                </div>
                <div className="cookie-consent-actions">
                    <button 
                        className="cookie-consent-btn cookie-consent-reject"
                        onClick={handleReject}
                    >
                        Reject & Return to OpenScore.org.uk
                    </button>
                    <button 
                        className="cookie-consent-btn cookie-consent-accept"
                        onClick={onAccept}
                    >
                        Accept Cookies
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
